import template from './ecocode-trustpilot-danger-text.html.twig';
import './ecocode-trustpilot-danger-text.scss';

const { Component } = Shopware;

Component.extend('ecocode-trustpilot-danger-text', 'sw-help-text', {
    template
});
